<template>
    <div class="check-list">
        <b-form-checkbox-group v-model="checked">
            <ul class="list-items">
                <li  v-for="(item, index) in items"
                     :key="index"
                     class="item">
                    <b-form-checkbox
                     :value="item"
                     unchecked-value=""
                    >
                        {{ item | deDash }}
                    </b-form-checkbox>
                </li>
            </ul>
        </b-form-checkbox-group>
    </div>
</template>

<script>
export default {
  name: 'check-list',
  filters: {
    deDash: function (string) {
      return string.replace(/-/g, ' ')
    }
  },
  props: {
    'value': {
      type: Array,
      required: true
    },
    'items': {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      checked: []
    }
  },
  watch: {
    checked () {
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style scoped lang="scss">
    .check-list {
        ul.list-items {
            margin: 0;
            padding: 1em 1.5em;

            li.item {
                margin: 0.3em 0;

               ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
                    background-color: var(--main-primary);
                }

               ::v-deep label {
                    font-size: 1.1em;
                    text-transform: capitalize;
                }
            }
        }
    }
</style>
